import { all, create, sin, cos, tan, csc, sec, cot } from 'mathjs';

const mathJSConfig = {
  angles: 'deg',
};
const mathInstance = create(all);
const wrap_trig_function = (func: any) => {
  return function (x: number) {
    if (mathJSConfig.angles === 'deg') {
      return func((x * Math.PI) / 180);
    }
    return func(x);
  };
};
mathInstance.import(
  {
    sin: wrap_trig_function(sin),
    cos: wrap_trig_function(cos),
    tan: wrap_trig_function(tan),
    csc: wrap_trig_function(csc),
    sec: wrap_trig_function(sec),
    cot: wrap_trig_function(cot),
  },
  { override: true }
);

export default mathInstance;
